import Alpine from 'alpinejs';
import { cspNonce } from '@rails/ujs';
import debounce from 'lodash.debounce';
import { csrfHeader } from '../../../../client/shared/axiosExport';

Alpine.data('remote', () => ({
  url: '',
  method: 'post',
  root: '',
  inputs: [],

  init() {
    // Initialize inputs from data attributes
    this.url = this.$el.dataset.url || '';
    this.method = this.$el.dataset.method || 'post';
    this.root = this.$el.dataset.root || '';

    // Find all input elements with data-input-name
    this.inputs = Array.from(this.$el.querySelectorAll('[data-input-name]'));

    // Set up debounced submit
    this.debouncedSubmit = debounce((e) => this.submit(e), 200);
  },

  submit(e) {
    if (!this.url) return;

    const formData = new FormData();
    formData.append(e.target.name, e.target.value);

    fetch(this.getURL(), {
      method: this.getMethod(),
      cache: 'no-cache',
      redirect: 'follow',
      headers: {
        'Accept': 'application/javascript,text/javascript',
        // 'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...csrfHeader,
      },
      body: formData,
    })
      .then(response => this.processResponse(response));
  },

  getMethod() {
    return this.method.toString().toUpperCase();
  },

  getURL() {
    if (!this.isGETRequest()) {
      return this.url;
    }

    const url = new URL(this.url, this.getBase());

    const getInputParam = (input) => {
      if (!this.root) return input.dataset.inputName;
      return `${this.root}[${input.dataset.inputName}]`;
    };

    this.inputs.reduce((obj, input) => {
      obj.set(getInputParam(input), input.value);
      return obj;
    }, url.searchParams);

    return url.pathname + url.search;
  },

  getBase() {
    return this.url.match(/\b(?:http|\/\/)\b/) ?
      undefined :
      window.location.origin;
  },

  isGETRequest() {
    return this.method.toString().toLowerCase() === 'get';
  },

  getBody() {
    if (this.isGETRequest()) {
      return {};
    }

    return { body: JSON.stringify(this.processedData()) };
  },

  processResponse(response) {
    const type = response.headers.get('content-type');
    response.text().then(data => {
      if (typeof data === 'string' && typeof type === 'string') {
        if (type.match(/\b(?:java|ecma)script\b/)) {
          let script = document.createElement('script');
          script.setAttribute('nonce', cspNonce());
          script.text = data;
          document.head.appendChild(script).parentNode.removeChild(script);
        }
      }
    });
  },

  processedData() {
    let data = this.inputs.reduce((obj, input) => {
      return {
        ...obj,
        [input.dataset.inputName]: input.value,
      };
    }, {});

    if (this.root) {
      data = { [this.root]: { ...data } };
    }

    return data;
  }
}));
